import React from "react";
import { makeStyles, useTheme } from "@mui/styles";
import { Grid, Box, useMediaQuery, Typography } from "@mui/material";

const CardSelect = ({
  fieldName,
  selected,
  values,
  onChange,
  multiple = false,
  ...props
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const selectedValues = multiple ? selected : [selected];

  const handleOptionClicked = (code) => {
    onChange(fieldName, code, multiple);
  };
  const useStyles = makeStyles(() => ({
    container: {
      display: "flex",
      columnGap: "12px",
      overflow: "auto",
      justifyContent: props.justifyContent,
    },
    option: {
      border: "1px solid hsl(160, 10%, 90%)",
      height: "52px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "20px",
      paddingRight: "20px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      flexGrow: 1,
      justifyContent: "center",
      backgroundColor: "#fff",
      color: "hsl(178, 93%, 10%)",
      transition: "border-color 0.2s, background-color 0.2s, color 0.2s",
      "&:hover": {
        borderColor: "hsl(153, 68%, 25%)",
      },
    },
    mobileOption: {
      border: "1px solid hsl(160, 10%, 90%)",
      height: "52px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: "16px",
      paddingRight: "16px",
      cursor: "pointer",
      whiteSpace: "wrap",
      backgroundColor: "#fff",
      color: "hsl(178, 93%, 10%)",
      transition: "border-color 0.2s, background-color 0.2s, color 0.2s",
      "&:hover": {
        borderColor: "hsl(153, 68%, 25%)",
      },
    },
    selectedOption: {
      color: "#fff",
      fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
      backgroundColor: "hsl(153, 68%, 25%)",
      borderColor: "hsl(153, 68%, 25%)",
      "&:hover": {
        borderColor: "hsl(153, 68%, 25%)",
      },
    },
  }));

  const classes = useStyles();
  return isDesktop ? (
    <Box className={classes.container}>
      {values.map((value) => (
        <Box
          key={value.code}
          className={`${classes.option} ${
            selectedValues.includes(value.code) ? classes.selectedOption : ""
          }`}
          onClick={() => handleOptionClicked(value.code)}
        >
          <Typography variant="body2bold">{value.label}</Typography>
        </Box>
      ))}
    </Box>
  ) : (
    <Grid container spacing={1}>
      {values.map((value) => (
        <Grid item xs={6} key={value.code}>
          <Box
            className={`${classes.mobileOption} ${
              selectedValues.includes(value.code) ? classes.selectedOption : ""
            }`}
            onClick={() => handleOptionClicked(value.code)}
          >
            <Typography variant="body2bold" textAlign="center">
              {value.label}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default CardSelect;
